/*
 * @Author: liuzongwan
 * @Date: 2024-02-21 14:26:13
 * @LastEditTime: 2025-11-06 15:44:33
 * @LastEditors: situgen@szkingdom.com
 * @Description:
 */

import { httpClient } from "@/assets/js/http";
import urls from "@/api/urls";
import cache from "@/assets/js/cache";
import util from "@/util";

function loginSms(data = {}) {
    return httpClient.post(urls.loginSms, data);
}

/* 登录 */
function login(data = {}) {
    return httpClient.post(urls.login, data);
}

/* 登出 */
function logout(data = {}) {
    return httpClient.post(urls.logout, data);
}

// 投资者信息补录查询
function getSuitableInfo(data = {}) {
    return httpClient.post(urls.suitableInfo, data);
}

// 投资者信息补录
function updateSuitableInfo(data = {}) {
    return httpClient.post(urls.updateSuitableInfo, data);
}

// 查询专业投资者信息
function acctProfessionalInfo(params = {}) {
    return httpClient.post(urls.acctProfessionalInfo, params);
}

// 判断是否符合转换成专业投资者条件
function acctChangetypeCheck(params = {}) {
    return httpClient.post(urls.acctChangetypeCheck, params);
}

// 普通转专业
function ordinary2Professional(params = {}) {
    return httpClient.post(urls.baseOrdinary2Professional, params);
}

// 专业转普通
function professional2Ordinary(params = {}) {
    return httpClient.post(urls.baseProfessional2Ordinary, params);
}

// 获取银行卡列表并过滤
function getBankCardList() {
    return new Promise((resolve, reject) => {
        Promise.all([getMyBankCards(), queryPaychannel()])
            .then(([res, channelRes]) => {
                res = res.data;
                // 列表
                let bankList = [];
                let paychannelbankInfoList = [];
                if (res.data) {
                    bankList = res.data ? res.data : [];
                    bankList = bankList.filter((item) => {
                        return (
                            ((util.showCounterCard() && util.remitOpen()) ||
                                item.banktype !== "1") && // 根据配置参数判断是否展示柜台的卡
                            item.ischannelstop === "1" // 屏蔽停用的卡（0-停用，1-正常）
                        );
                    });
                    // 激活字段
                    bankList.forEach((bankItem) => {
                        let tip;
                        if (bankItem.hkcardflag === "1") {
                            // 汇款模式银行卡 3.0为hkmode
                            tip = "汇款模式卡不支持激活";
                        } else if (bankItem.authenticateflag === "1") {
                            tip = "银行卡已激活";
                        } else {
                            tip = "";
                        }
                        bankItem.activeDisabledTip = tip;
                    });
                    if (channelRes.data) {
                        paychannelbankInfoList = channelRes.data.paychannelbankInfoList
                            ? channelRes.data.paychannelbankInfoList
                            : [];
                        if (cache.getUser().certificatetype === "0B") {
                            paychannelbankInfoList = paychannelbankInfoList.filter((item) => {
                                return item.specialflag && item.specialflag.indexOf("8") > -1;
                            });
                        }
                        const _arr = channelRes.data.paychannelInfoList
                            ? channelRes.data.paychannelInfoList
                            : [];
                        bankList.forEach((bankItem, bankIndex) => {
                            if (bankItem.specialflagofchannel.indexOf("t") > -1) {
                                bankList[bankIndex]["identifytype"] = "1";
                            } else if (bankItem.specialflagofchannel.indexOf("u") > -1) {
                                bankList[bankIndex]["identifytype"] = "2";
                            } else {
                                bankList[bankIndex]["identifytype"] = "0";
                            }
                            _arr.forEach((channelItem) => {
                                if (bankItem.paycenterid == channelItem.paychannel) {
                                    // 8为后台解约，a为页面解约
                                    if (channelItem.businessflag.indexOf("8") > -1) {
                                        bankList[bankIndex]["unsigntype"] = "1";
                                    } else if (channelItem.businessflag.indexOf("a") > -1) {
                                        bankList[bankIndex]["unsigntype"] = "2";
                                    } else {
                                        bankList[bankIndex]["unsigntype"] = "0";
                                    }
                                    if (bankList[bankIndex].identifytype == "0") {
                                        if (channelItem.businessflag.indexOf("s") > -1) {
                                            bankList[bankIndex]["identifytype"] = "1";
                                        } else if (channelItem.businessflag.indexOf("r") > -1) {
                                            bankList[bankIndex]["identifytype"] = "2";
                                        }
                                    }
                                }
                            });
                        });
                    }
                }
                resolve({ bankList: bankList, paychannelbankInfoList: paychannelbankInfoList });
            })
            .catch((e) => {
                reject(e);
            });
    });
}

// 获取银行卡列表
function getMyBankCards(data = {}) {
    return httpClient.post(urls.myBankCards, data);
}

// 获取银行卡网点列表
function queryPaychannel(data = {}) {
    return httpClient.post(urls.queryPaychannel, data);
}

// 获取可增银行卡网点列表
function qryAddableBankList(data = {}) {
    return httpClient.post(urls.banks, data);
}

// 查询待适当性处理协议
function getSuitableList(data = {}) {
    return httpClient.post(urls.suitableHandleList, data);
}
//  查询涉税信息
function qryAcctCrsInfoService(data = {}) {
    return httpClient.post(urls.qryAcctCrsInfoService, data);
}
//  新增涉税信息
function addAcctCrsInfoHandler(data = {}) {
    return httpClient.post(urls.addAcctCrsInfoHandler, data);
}
//  删除涉税信息
function delAcctCrsInfoHandler(data = {}) {
    return httpClient.post(urls.delAcctCrsInfoHandler, data);
}
//  修改涉税信息
function updAcctCrsInfoHandler(data = {}) {
    return httpClient.post(urls.updAcctCrsInfoHandler, data);
}

/* 编辑个人信息 */
function updAcctInfo(data = {}, isKen = false, retain = false) {
    // 姓名 证件号码 手机号码 邮件传密文值 邮件改动传输入值
    if (cache.getIsEncrypted()) {
        isKen = true;
        // 当retain为true需求需保留作为入参
        if (!retain) {
            delete data.certificateno;
        }
        delete data.custname;
        delete data.mobileno;
        // 邮箱
        if (data.email == cache.getUser().email) {
            delete data.email;
        }
        // 实际受益人姓名 实际受益人证件号码 实际受益人手机号 实际控制人姓名 实际控制人人证件号码 实际控制人手机号
        if (data.benefitname == cache.getUser().benefitname) {
            delete data.benefitname;
        } else if (data.benefitname && data.benefitname != cache.getUser().benefitname) {
            delete data.en_benefitname;
        }

        if (data.benefitcertificateno == cache.getUser().benefitcertificateno) {
            delete data.benefitcertificateno;
        } else if (
            data.benefitcertificateno &&
            data.benefitcertificateno != cache.getUser().benefitcertificateno
        ) {
            delete data.en_benefitcertificateno;
        }

        if (data.benefittelno == cache.getUser().benefittelno) {
            delete data.benefittelno;
        } else if (data.benefittelno && data.benefittelno != cache.getUser().benefittelno) {
            delete data.en_benefittelno;
        }

        if (data.actualctrlname == cache.getUser().actualctrlname) {
            delete data.actualctrlname;
        } else if (data.actualctrlname && data.actualctrlname != cache.getUser().actualctrlname) {
            delete data.en_actualctrlname;
        }

        if (data.actualctrlcerno == cache.getUser().actualctrlcerno) {
            delete data.actualctrlcerno;
        } else if (
            data.actualctrlcerno &&
            data.actualctrlcerno != cache.getUser().actualctrlcerno
        ) {
            delete data.en_actualctrlcerno;
        }

        if (data.actualctrltelno == cache.getUser().actualctrltelno) {
            delete data.actualctrltelno;
        } else if (
            data.actualctrltelno &&
            data.actualctrltelno != cache.getUser().actualctrltelno
        ) {
            delete data.en_actualctrltelno;
        }
    }
    return httpClient.post(urls.updAcctInfo, data, {
        headers: isKen ? { k_en: "m" } : {}
    });
}

/* 修改登录密码 */
function combLoginPasswordUpdate(data = {}) {
    return httpClient.post(urls.combLoginPasswordUpdate, data);
}

// 适当性协议
function getProtocol(data = {}) {
    return httpClient.post(urls.sdxProtocol, data);
}

// 检查客户风险
function acctRiskListManage(data = {}, isKen = false) {
    return httpClient.post(urls.acctRiskListManage, data, {
        headers: isKen ? { k_en: "m" } : {}
    });
}

// 风险测评题目
function selectQuestionAndOption(data = {}) {
    return httpClient.post(urls.selectQuestionAndOption, data);
}

// 提交风测
function combCustRiskService(data = {}) {
    return httpClient.post(urls.combCustRiskService, data);
}

// 查询专业投资者信息
function combQueryProInvestInfo(data = {}) {
    return httpClient.post(urls.combQueryProInvestInfo, data);
}
function changeTradePwd(data = {}) {
    return httpClient.post(urls.changeTradePwd, data);
}

// 获取图形验证码
function getAuthCode(data = {}) {
    return httpClient.post(urls.getAuthCode, data);
}

// 发送短信验证码
function sendSms(data = {}, isKen = false) {
    return httpClient.post(urls.sendSms, data, {
        headers: isKen ? { k_en: "m" } : {}
    });
}

// 校验短信验证码
function checkSmsCode(data = {}) {
    return httpClient.post(urls.checkSmsCode, data);
}

// 绑定手机号修改
function modifyMobile(data = {}, isKen = false) {
    return httpClient.post(urls.modifyMobile, data, {
        headers: isKen ? { k_en: "m" } : {}
    });
}
// 手机号解绑
function unbindMobile(data = {}, isKen = false) {
    return httpClient.post(urls.unbindMobile, data, {
        headers: isKen ? { k_en: "m" } : {}
    });
}
// 手机号绑定
function bindMobile(data = {}, isKen = false) {
    return httpClient.post(urls.bindMobile, data, {
        headers: isKen ? { k_en: "m" } : {}
    });
}

// 解绑银行卡
function delBankCard(data = {}) {
    return httpClient.post(urls.delBankCard, data);
}

// 根据渠道删除已绑定银行卡
function delCardPayChannel(data = {}) {
    return httpClient.post(urls.delCardPayChannel, data);
}

// 更改头像
function modifyAcctExt(data = {}) {
    return httpClient.post(urls.modifyAcctExt, data);
}

// 添加银行卡
function combBankCardCreate(data = {}, isKen = false) {
    return httpClient.post(urls.combBankCardCreate, data, {
        headers: isKen ? { k_en: "m" } : {}
    });
}

// 修改银行卡信息
function combBankCardInfoUpdate(data = {}, isKen = false) {
    return httpClient.post(urls.combBankCardInfoUpdate, data, {
        headers: isKen ? { k_en: "m" } : {}
    });
}

// 查询联行号与开户行名称
function bankBranch(data = {}) {
    return httpClient.post(urls.bankBranch, data);
}

// 发送增卡短信
function sendBindCardSms(data = {}, isKen = false) {
    return httpClient.post(urls.sendBindCardSms, data, {
        headers: isKen ? { k_en: "m" } : {}
    });
}

// 校验增卡短信
function checkBindCardSms(data = {}, isKen = false) {
    let bankgateserialno = sessionStorage.getItem("bankgateserialno");
    if (bankgateserialno) {
        data.bankgateserialno = bankgateserialno;
    }
    return httpClient.post(urls.checkBindCardSms, data, {
        headers: isKen ? { k_en: "m" } : {}
    });
}

// 添加汇款卡
function combPayChannelCreate(data = {}) {
    return httpClient.post(urls.checkBindCardSms, data);
}

// 添加银行卡
function addBankCard(data = {}, isKen = false) {
    let bankgateserialno = sessionStorage.getItem("bankgateserialno");
    if (bankgateserialno) {
        data.bankgateserialno = bankgateserialno;
    }
    return httpClient.post(urls.addBankCard, data, {
        headers: isKen ? { k_en: "m" } : {}
    });
}
// 开户接口

function openAcct(data = {}, isKen = false) {
    return httpClient.post(urls.openAcct, data, {
        headers: isKen ? { k_en: "m" } : {}
    });
}

// 激活银行卡
function combUpdateBankcardAuth(data = {}, isKen = false) {
    return httpClient.post(urls.combUpdateBankcardAuth, data, {
        headers: isKen ? { k_en: "m" } : {}
    });
}

// 发送页面签约
function combSignApply(data = {}) {
    return httpClient.post(urls.combSignApply, data);
}

// 校验页面签约
function combSignConfirm(data = {}, isKen = false) {
    return httpClient.post(urls.combSignConfirm, data, {
        headers: isKen ? { k_en: "m" } : {}
    });
}

// 校验页面鉴权
function combVerifyConfirm(data = {}, isKen = false) {
    return httpClient.post(urls.combVerifyConfirm, data, {
        headers: isKen ? { k_en: "m" } : {}
    });
}

// 支付方式解约申请
function combUnSignApply(data = {}, isKen = false) {
    return httpClient.post(urls.combUnSignApply, data, {
        headers: isKen ? { k_en: "m" } : {}
    });
}

// 支付方式解约验证
function combUnSignConfirm(data = {}, isKen = false) {
    return httpClient.post(urls.combUnSignConfirm, data, {
        headers: isKen ? { k_en: "m" } : {}
    });
}

// 页面鉴权银行返回报文
function qryBankCallbackInfo(data = {}) {
    return httpClient.post(urls.qryBankCallbackInfo, data);
}
// 页面鉴权建行网银直连渠道返回报文
function qryCcbBankData(data = {}) {
    return httpClient.post(urls.qryCcbBankData, data);
}
// 提交知识测评
function custKnowledgeRisk(data = {}) {
    return httpClient.post(urls.custKnowledgeRisk, data);
}

// 重置密码校验用户信息
function resetLoginPwdVerify(data = {}) {
    return httpClient.post(urls.resetLoginPwdVerify, data);
}

// 重置登录密码
function resetLoginPwd(data = {}) {
    return httpClient.post(urls.resetLoginPwd, data);
}
// 检查是否开户
function isOpenAcct(data = {}) {
    return httpClient.post(urls.isOpenAcct, data);
}
// 绑定已开户账号
function bindAccount(data = {}) {
    return httpClient.post(urls.bindAccount, data);
}
function qryRemittanceInfo(data = {}) {
    return httpClient.post(urls.qryRemittanceInfo, data);
}

function getInfoByPaychannel(data = {}) {
    return httpClient.post(urls.getInfoByPaychannel, data);
}

function updateLoginPwd(data = {}) {
    return httpClient.post(urls.updateLoginPwd, data);
}
/* 注册留痕 */
function addPolicyLog(data = {}) {
    return httpClient.post(urls.addPolicyLog, data);
}

// 证件信息核验  只支持身份证信息核验
function combPersonAuth(data = {}, isKen = false) {
    return httpClient.post(urls.combPersonAuth, data, {
        headers: isKen ? { k_en: "m" } : {}
    });
}

// 发送邮件验证码
function sendEmail(data = {}) {
    return httpClient.post(urls.sendEmail, data);
}

// 验证邮件验证码
function checkEmailCode(data = {}) {
    return httpClient.post(urls.checkEmailCode, data);
}

// 修改邮箱
function modifyEmail(data = {}) {
    return httpClient.post(urls.modifyEmail, data);
}
// 查询积分
function qryCrmCustInfo(data = {}) {
    return httpClient.post(urls.qryCrmCustInfo, data);
}

// 查询服务定制
function qryCustomizedServer(data = {}) {
    return httpClient.post(urls.qryCustomizedServer, data);
}

// 修改定制服务
function modifyCustomizedServer(data = {}) {
    return httpClient.post(urls.modifyCustomizedServer, data);
}

// 查询CRM对账单
function qryCrmStatements(data = {}) {
    return httpClient.post(urls.qryCrmStatements, data);
}

// 银行卡换卡记录查询
function combQueryAppOnlineCardChange(data = {}) {
    return httpClient.post(urls.combQueryAppOnlineCardChange, data);
}

// 银行卡变更
function combBankCardUpdate(data = {}, isKen = false) {
    return httpClient.post(urls.combBankCardUpdate, data, {
        headers: isKen ? { k_en: "m" } : {}
    });
}

// 银行卡换卡
function appOnlineCardChange(data = {}, isKen = false) {
    return httpClient.post(urls.appOnlineCardChange, data, {
        headers: isKen ? { k_en: "m" } : {}
    });
}

// 修改手机号鉴权申请
function modifyMobileAuthApply(data = {}, isKen = false) {
    return httpClient.post(urls.modifyMobileAuthApply, data, {
        headers: isKen ? { k_en: "m" } : {}
    });
}

// 修改手机号鉴权验证
function modifyMobileAuthConfirm(data = {}) {
    return httpClient.post(urls.modifyMobileAuthConfirm, data);
}

// 银行卡变更（预检）
function combBankCardUpdatePreCheck(data = {}) {
    return httpClient.post(urls.combBankCardUpdatePreCheck, data);
}
// 换卡前校验
function combBankCardPrepare(data = {}, isKen = false) {
    return httpClient.post(urls.combBankCardPrepare, data, {
        headers: isKen ? { k_en: "m" } : {}
    });
}

// 重置交易密码
function resetTradePwd(data = {}) {
    return httpClient.post(urls.resetTradePwd, data);
}

// 注册用户开户后更新缓存信息
function openAcctAfterUpd(data = {}, isKen = false) {
    return httpClient.post(urls.openAcctAfterUpd, data, {
        headers: isKen ? { k_en: "m" } : {}
    });
}

// 免注册开户获取登录令牌
function openAcctAfterToken(data = {}) {
    return httpClient.post(urls.openAcctAfterToken, data);
}

// 后台解约银行卡
function combUnSignBankHandler(data = {}, isKen = false) {
    return httpClient.post(urls.combUnSignBankHandler, data, {
        headers: isKen ? { k_en: "m" } : {}
    });
}

// 校验交易密码
function combPasswordCheck(data = {}) {
    return httpClient.post(urls.combPasswordCheck, data);
}

// 自助换卡记录查询
function combQueryAppAcctList(data = {}) {
    return httpClient.post(urls.combQueryAppAcctList, data);
}

// 反洗钱黑名单查询
function qryBlackListService(data = {}, isKen = false) {
    return httpClient.post(urls.qryBlackListService, data, {
        headers: isKen ? { k_en: "m" } : {}
    });
}

function acctBeforeLoginCheck(data = {}) {
    return httpClient.post(urls.acctBeforeLoginCheck, data);
}

function bindCheck(data = {}) {
    return httpClient.post(urls.bindCheck, data);
}

function bindMobileno(data = {}) {
    return httpClient.post(urls.bindMobileno, data);
}

// 判断用户某些新数据是否与原数据一样
function verifyService(data = {}) {
    return httpClient.post(urls.verifyService, data);
}
// 更新预留信息
function updRemark(data = {}) {
    return httpClient.post(urls.updRemark, data);
}
// 留痕信息查询
function qryAcctTracesLogList(data = {}) {
    return httpClient.post(urls.qryAcctTracesLogList, data);
}
// 销户
function closeAccountMid(data = {}) {
    return httpClient.post(urls.closeAccountMid, data);
}

// 查询定投首次扣款日
function getFirstPlanDay(data = {}) {
    return httpClient.post(urls.getFirstPlanDay, data);
}

// 查询待签署合同
function queryAwaitSignElecontract(data = {}) {
    return httpClient.post(urls.queryAwaitSignElecontract, data);
}

function checkRiskInfo(data = {}) {
    return httpClient.post(urls.checkRiskInfo, data);
}

function acctRiskinfoQuery(data = {}) {
    return httpClient.post(urls.acctRiskinfoQuery, data);
}

function combRiskGardeQuery(data = {}) {
    return httpClient.post(urls.combRiskGardeQuery, data);
}

// 终端电子合同签署
function combAppEleontractSign(data = {}) {
    return httpClient.post(urls.combAppEleontractSign, data);
}

// 忘记密码发送
function restPwdAuthSend(data = {}, isKen = false) {
    return httpClient.post(urls.restPwdAuthSend, data, {
        headers: isKen ? { k_en: "m" } : {}
    });
}

// 忘记密码校验
function restPwdAuthReceive(data = {}, isKen = false) {
    return httpClient.post(urls.restPwdAuthReceive, data, {
        headers: isKen ? { k_en: "m" } : {}
    });
}

// 纯注册重置登录密码
function resetPwdRegister(data = {}) {
    return httpClient.post(urls.resetPwdRegister, data);
}

// 重置纯代销密码
function resetPwdSearch(data = {}) {
    return httpClient.post(urls.resetPwdSearch, data);
}

// 校验实名信息
function identifyVerification(data = {}) {
    return httpClient.post(urls.identifyVerification, data);
}

// 查询投资者回访状态
function qryReturnVisitStatus(data = {}) {
    return httpClient.post(urls.qryReturnVisitStatus, data);
}

// 修改投资者回访状态
function upReturnVisitStatus(data = {}) {
    return httpClient.post(urls.upReturnVisitStatus, data);
}

// 电子签署约定书
function modifySmAuthorization(data = {}) {
    return httpClient.post(urls.modifySmAuthorization, data);
}

// 业务查询银行卡
function combQryActivatedBankCard(data = {}) {
    return httpClient.post(urls.combQryActivatedBankCard, data);
}

function setQryAllFund(data = {}) {
    return httpClient.post(urls.setQryallfund, data);
}

export default {
    qryCrmCustInfo,
    qryRemittanceInfo,
    getInfoByPaychannel,
    openAcct,
    loginSms,
    login,
    logout,
    getSuitableInfo,
    updateSuitableInfo,
    getBankCardList,
    getMyBankCards,
    acctProfessionalInfo,
    acctChangetypeCheck,
    ordinary2Professional,
    professional2Ordinary,
    queryPaychannel,
    qryAddableBankList,
    getSuitableList,
    updAcctInfo,
    combLoginPasswordUpdate,
    getProtocol,
    acctRiskListManage,
    addAcctCrsInfoHandler,
    qryAcctCrsInfoService,
    delAcctCrsInfoHandler,
    updAcctCrsInfoHandler,
    selectQuestionAndOption,
    combCustRiskService,
    combQueryProInvestInfo,
    getAuthCode,
    sendSms,
    checkSmsCode,
    modifyMobile,
    unbindMobile,
    bindMobile,
    delBankCard,
    delCardPayChannel,
    modifyAcctExt,
    combBankCardCreate,
    combBankCardInfoUpdate,
    bankBranch,
    sendBindCardSms,
    checkBindCardSms,
    combPayChannelCreate,
    addBankCard,
    changeTradePwd,
    combUpdateBankcardAuth,
    combSignApply,
    combSignConfirm,
    combVerifyConfirm,
    combUnSignApply,
    combUnSignConfirm,
    qryBankCallbackInfo,
    qryCcbBankData,
    custKnowledgeRisk,
    resetLoginPwdVerify,
    resetLoginPwd,
    updateLoginPwd,
    addPolicyLog,
    combPersonAuth,
    isOpenAcct,
    bindAccount,
    sendEmail,
    checkEmailCode,
    modifyEmail,
    qryCustomizedServer,
    modifyCustomizedServer,
    qryCrmStatements,
    combQueryAppOnlineCardChange,
    combBankCardUpdate,
    appOnlineCardChange,
    modifyMobileAuthApply,
    modifyMobileAuthConfirm,
    combBankCardUpdatePreCheck,
    combBankCardPrepare,
    resetTradePwd,
    openAcctAfterUpd,
    openAcctAfterToken,
    combUnSignBankHandler,
    combPasswordCheck,
    combQueryAppAcctList,
    qryBlackListService,
    acctBeforeLoginCheck,
    bindCheck,
    bindMobileno,
    verifyService,
    updRemark,
    qryAcctTracesLogList,
    closeAccountMid,
    getFirstPlanDay,
    queryAwaitSignElecontract,
    checkRiskInfo,
    acctRiskinfoQuery,
    combRiskGardeQuery,
    combAppEleontractSign,
    restPwdAuthSend,
    restPwdAuthReceive,
    resetPwdRegister,
    resetPwdSearch,
    identifyVerification,
    qryReturnVisitStatus,
    upReturnVisitStatus,
    modifySmAuthorization,
    combQryActivatedBankCard,
    setQryAllFund
};
